module.exports = __webpack_public_path__ + "f2de3792a82c1d09f79a10bd89a153a5.png";